export const helper = {
  formatPrice(Number) {
    Number += "";
    Number = Number.replace(",", "");
    const x = Number.split(".");
    let y = x[0];
    const z = x.length > 1 ? "." + x[1] : "";
    const rgx = /(\d+)(\d{3})/;
    while (rgx.test(y)) y = y.replace(rgx, "$1" + "," + "$2");
    return y + z;
  },
  calculateChartSeriesTotal(series) {
    if (series.length > 0) {
      const reducer = (accumulator, curr) => accumulator + curr;
      return series.reduce(reducer);
    } else {
      return 0;
    }
  },
  shuffle(a) {
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  },
};
